var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPessegoCare = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 76,
  height: 80,
  viewBox: "0 0 76 80",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.8637 21.8181C46.4875 21.8181 38.0758 30.5012 38.0758 41.2121C38.0758 30.5012 29.6641 21.8181 19.2879 21.8181C8.91172 21.8181 0.5 30.5012 0.5 41.2121C0.5 62.6343 17.3231 80 38.0758 80C58.8286 80 75.6516 62.6343 75.6516 41.2121C75.6516 30.5012 67.2399 21.8181 56.8637 21.8181Z",
  fill: "#F26522"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.2582 9.35004H40.7431C38.6008 9.35004 36.8643 11.1334 36.8643 13.3334V26.6667C41.4889 20.9546 48.4595 17.3167 56.2582 17.3167H71.7734C73.9157 17.3167 75.6522 15.5329 75.6522 13.3334V0C71.0275 5.71208 64.0569 9.35004 56.2582 9.35004Z",
  fill: "#F26522"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M38 63C47.9411 63 56 54.9411 56 45H63C63 48.283 62.3534 51.5339 61.097 54.5671C59.8406 57.6002 57.9991 60.3562 55.6777 62.6777C53.3562 64.9991 50.6002 66.8406 47.5671 68.097C44.5339 69.3534 41.283 70 38 70C34.717 70 31.4661 69.3534 28.4329 68.097C25.3998 66.8406 22.6438 64.9991 20.3223 62.6777C18.0009 60.3562 16.1594 57.6002 14.903 54.5671C13.6466 51.5339 13 48.283 13 45L20 45C20 54.9411 28.0589 63 38 63Z",
  fill: "white"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPessegoCare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pessego-care.3fe4dcaa.svg";
export { ForwardRef as ReactComponent };